import { render, staticRenderFns } from "./hospitalmanagement.vue?vue&type=template&id=0d8aefb6&scoped=true&"
import script from "./hospitalmanagement.vue?vue&type=script&lang=js&"
export * from "./hospitalmanagement.vue?vue&type=script&lang=js&"
import style0 from "./hospitalmanagement.vue?vue&type=style&index=0&id=0d8aefb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8aefb6",
  null
  
)

export default component.exports